<span [ngSwitch]="value">
  <span class="badge bg-primary" *ngSwitchCase="'OPEN'"> {{'developmentDemandStatusValue.'+value | translate}}</span>
  <span class="badge bg-secondary" *ngSwitchCase="'MERGED'"> {{'developmentDemandStatusValue.'+value | translate}}</span>
  <span class="badge bg-warning" *ngSwitchCase="'APPROVED'"> {{'developmentDemandStatusValue.'+value | translate}}</span>
  <span class="badge bg-warning" *ngSwitchCase="'IN_PROGRESS'"> {{'developmentDemandStatusValue.'+value | translate}}</span>
  <span class="badge bg-success" *ngSwitchCase="'COMPLETED'"> {{'developmentDemandStatusValue.'+value | translate}}</span>
  <span class="badge bg-danger" *ngSwitchCase="'CANCELED'"> {{'developmentDemandStatusValue.'+value | translate}}</span>
  <span class="badge bg-secondary" *ngSwitchDefault> {{'developmentDemandStatusValue.'+value | translate}}</span>
</span>
